import axios from "@/plugins/axios";
import type { AxiosInstance } from "axios";
import router from "@/router";

import { useAuthStore } from "../stores/auth";
import { usePwaStore } from "../stores/pwa";
import { useAlertStore } from "../stores/alert";
import { useGlobalStateStore } from "@/stores/global";

export default abstract class BaseService {
	constructor () {
		this.url = "";
	}

	api!: AxiosInstance;
	url: string;

	setupAPI (baseURL: any) {
		const authStore = useAuthStore();
		const pwaStore = usePwaStore();
		const alertStore = useAlertStore();
		const globalStateStore = useGlobalStateStore();

		axios.interceptors.response.use(
			response => {
				// Clear timeout if needed
				clearTimeout((response.config as any)?.metadata?.timeoutId);
				// Return response if it's successful
				return response;
			},
			error => {
				const status = error?.response?.status;
				clearTimeout((error.config as any)?.metadata?.timeoutId);
				// const L = (error.config as any)?.metadata?.maxtime;

				// // ✅ Catch request aborted by AbortController
				// if (error.code === "ERR_CANCELED" || error.name === "CanceledError") {
				// 	console.warn("Request was aborted after " + L + "ms (request timed out):", error.config?.url);

				// 	if (pwaStore.manuallyOnline &&
				// 		confirm("Updates to the server are taking longer than usual. Would you like to change to working offline? You can go back online later when data or wifi service improves."))
				// 		pwaStore.setManuallyOnline(false);

				// 	// Optional: toast or alert
				// 	// alertStore.warn("Updates to the server are taking longer than usual. App settings have been updated to work in offline mode.");

				// 	// Optional: set error state in store
				// 	// pwaStore.networkIssue = true;
				// }

				// ✅ Handle session expiry
				if (error.response && (status === 419 || status === 401)) {
					// if (router.currentRoute.value.name !== "login"
					// 	&& !globalStateStore.sessionExpired
					// 	// && !globalStateStore.showReLoginModal
					// ) {
					// 	// only show the reauth modal if: we have a user, we have data, and the user has sync enabled
					// 	// todo: do we do this is there's an update in progress?
					// 	if (authStore.user) {
					// 		if (pwaStore.manuallyOnline && pwaStore.onlineAndConnected)
					// 			globalStateStore.sessionExpired = true;
					// 	}
					// 	console.warn("Session expired (axios caught), refreshing");
					// }
				}

				// Propagate error downstream
				return Promise.reject(error);
			}
		);
		this.api = axios;
		this.api.defaults.baseURL = baseURL;
		this.api.defaults.withCredentials = true;
	}

	protected post (url: any, data: any, config = {}) {
		return this.api.post(url, data, config);
	}

	protected put (url: any, data: any, config = {}) {
		if (data instanceof FormData) {
			data.append("_method", "PUT");
		} else {
			data._method = "PUT";
		}
		return this.api.post(url, data, config);
	}

	protected patch (url: any, data: any, config = {}) {
		if (data instanceof FormData) {
			data.append("_method", "PATCH");
		} else {
			data._method = "PATCH";
		}
		return this.api.post(url, data, config);
	}

	protected get (url: any, config = {}) {
		return this.api.get(url, config);
	}

	protected delete (url: any, config = {}) {
		return this.api.delete(url, config);
	}

	protected head (url: string): Promise<unknown> {
		return this.api.head(url);
	}
}

